// Format a time string like "18:00", "18:00:00", "9:5", or "6:00 PM" → "6:00 PM"
export function formatTime12(t) {
  if (!t) return "";
  const s = String(t).trim();
  if (/am|pm/i.test(s)) return s.toUpperCase();
  const m = s.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
  if (!m) return s;
  let h = parseInt(m[1], 10);
  const min = m[2];
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${min} ${ampm}`;
}

export function formatDateLong(iso) {
  if (!iso) return "—";
  try {
    const s = iso.length === 10 ? iso + "T00:00:00" : iso;
    return new Date(s).toLocaleDateString(undefined, {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return iso;
  }
}
